fos.Router.setData({
	"base_url": "",
	"routes": {
		"class4kidsmanage_core_restapi_v1_authentication_login_login": {
			"tokens": [
				["text", "\/rest\/v1\/authentication\/login"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_get_public_schedule": {
			"tokens": [
				["text", "\/api\/v4\/public\/schedule\/current"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"api_v4_register_iframe": {
			"tokens": [
				["text", "\/api\/v4\/public\/schedule\/browser-analytics"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST", "GET"],
			"schemes": []
		},
		"api_v4_get_latest_parent_contract": {
			"tokens": [
				["text", "\/api\/v4\/public\/contract\/parent\/latest"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"api_v4_get_latest_parent_summary": {
			"tokens": [
				["text", "\/api\/v4\/public\/contract\/parent\/summary"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"api_v4_get_latest_coach_contract": {
			"tokens": [
				["text", "\/api\/v4\/public\/contract\/coach\/latest"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"api_v4_get_latest_coach_summary": {
			"tokens": [
				["text", "\/api\/v4\/public\/contract\/coach\/summary"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"api_v4_check_email_status": {
			"tokens": [
				["text", "\/api\/v4\/public\/authentication\/email-status-check"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_login": {
			"tokens": [
				["text", "\/api\/v4\/public\/authentication\/login-user"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_signup_new_user": {
			"tokens": [
				["text", "\/api\/v4\/public\/signup\/new-user"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_send_sign_up_to_google_sheets": {
			"tokens": [
				["text", "\/api\/v4\/public\/signup\/log-sign-up"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_cached_search_premium_listings": {
			"tokens": [
				["text", "\/api\/v4\/public\/search\/cached\/premium-listings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET", "POST"],
			"schemes": []
		},
		"api_v4_get_outstanding_subscriptions": {
			"tokens": [
				["text", "\/api\/v4\/parent\/subscriptions\/outstanding"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_get_outstanding_subscription_invoices": {
			"tokens": [
				["text", "\/api\/v4\/parent\/subscriptions\/outstanding\/invoices"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_pay_outstanding_subscription_invoices": {
			"tokens": [
				["text", "\/api\/v4\/parent\/subscriptions\/outstanding\/pay"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_update_default_card_for_customer_with_client_stripe": {
			"tokens": [
				["text", "\/api\/v4\/parent\/subscriptions\/outstanding\/update-default-card-client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_get_subscription_from_stripe": {
			"tokens": [
				["text", "\/api\/v4\/parent\/subscriptions\/all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_get_subscription_details_from_stripe": {
			"tokens": [
				["text", "\/api\/v4\/parent\/subscriptions\/all\/detail"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_add_new_card": {
			"tokens": [
				["text", "\/api\/v4\/parent\/payments\/saved-cards\/add"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_delete_saved_card": {
			"tokens": [
				["text", "\/api\/v4\/parent\/payments\/saved-cards\/delete"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_get_payment_settings": {
			"tokens": [
				["text", "\/api\/v4\/parent\/payments\/payment-settings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"api_v4_pay_order": {
			"tokens": [
				["variable", "\/", "[^\/]++", "stripeToken"],
				["text", "\/pay"],
				["variable", "\/", "[^\/]++", "orderId"],
				["text", "\/api\/v4\/parent\/payments"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_pay_basket": {
			"tokens": [
				["text", "\/api\/v4\/parent\/payments\/pay"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_get_parent_details": {
			"tokens": [
				["text", "\/api\/v4\/parent\/user\/detail"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_get_user_marketing_preferences": {
			"tokens": [
				["text", "\/api\/v4\/parent\/user\/marketing-preferences"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"api_v4_set_user_marketing_preferences": {
			"tokens": [
				["text", "\/api\/v4\/parent\/user\/marketing-preferences"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"api_v4_update_parent_details": {
			"tokens": [
				["text", "\/api\/v4\/parent\/user\/update"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"api_v4_client_get_logo_urls": {
			"tokens": [
				["text", "\/api\/v4\/parent\/clients\/logo-urls"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_schedule": {
			"tokens": [
				["text", "\/api\/v4\/camps\/schedule"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_weeks": {
			"tokens": [
				["text", "\/weeks"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/v4\/camps"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_camp_register": {
			"tokens": [
				["text", "\/register"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/v4\/camps"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_details": {
			"tokens": [
				["text", "\/details"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/v4\/camps"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_week_days": {
			"tokens": [
				["text", "\/days"],
				["variable", "\/", "[^\/]++", "weekId"],
				["text", "\/week"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/v4\/camps"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_bookings": {
			"tokens": [
				["text", "\/bookings"],
				["variable", "\/", "[^\/]++", "dayOfWeek"],
				["text", "\/day"],
				["variable", "\/", "[^\/]++", "weekId"],
				["text", "\/week"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/v4\/camps"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_bookings_count": {
			"tokens": [
				["text", "\/api\/v4\/camps\/count\/bookings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_paid_amount": {
			"tokens": [
				["text", "\/api\/v4\/camps\/paid"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_due_amount": {
			"tokens": [
				["text", "\/api\/v4\/camps\/due"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_update_camp_attendance": {
			"tokens": [
				["variable", "\/", "[^\/]++", "bookingInstanceId"],
				["text", "\/api\/v4\/camps\/update\/attendance\/bookingInstance"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"Api_v4_update_camp_instance_group_label": {
			"tokens": [
				["text", "\/api\/v4\/camps\/update\/instanceGroups\/label"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_amend_camp_booking": {
			"tokens": [
				["text", "\/api\/v4\/camps\/edit\/booking\/amend"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_camp_booking": {
			"tokens": [
				["variable", "\/", "[^\/]++", "bookingId"],
				["text", "\/api\/v4\/camps\/edit\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp_booking_price": {
			"tokens": [
				["text", "\/price"],
				["variable", "\/", "[^\/]++", "bookingId"],
				["text", "\/api\/v4\/camps\/edit\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camp": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/v4\/camps"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_V4_create_run_instance": {
			"tokens": [
				["text", "\/api\/v4\/camps\/edit\/run-instance"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_V4_create_run_instance_type": {
			"tokens": [
				["text", "\/api\/v4\/camps\/edit\/run-instance\/type"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_update_camp_run_instance": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runInstanceId"],
				["text", "\/api\/v4\/camps\/edit\/run-instance"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["PUT"],
			"schemes": []
		},
		"Api_v4_update_camp_instance_group": {
			"tokens": [
				["text", "\/api\/v4\/camps\/instance-group\/update"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_V4_create_instance_group": {
			"tokens": [
				["text", "\/api\/v4\/camps\/instance-group"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_reporting_schedule": {
			"tokens": [
				["text", "\/api\/v4\/reporting\/incomeanalysis"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_client_spend_detail": {
			"tokens": [
				["text", "\/detail"],
				["variable", "\/", "[^\/]++", "clientId"],
				["text", "\/api\/v4\/reporting"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_client_stripe_ayout_details": {
			"tokens": [
				["text", "\/api\/v4\/reporting\/stripe-payout-details"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_schedule_capactiy": {
			"tokens": [
				["text", "\/api\/v4\/reporting\/schedule-capacity"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_kids": {
			"tokens": [
				["text", "\/api\/v4\/people\/parent\/children"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_mark_message_as_read": {
			"tokens": [
				["text", "\/api\/v4\/people\/messages\/read"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_child_details": {
			"tokens": [
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/api\/v4\/people\/child"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_edit_parent_details": {
			"tokens": [
				["text", "\/api\/v4\/people\/parent\/edit"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"Api_v4_edit_child_details": {
			"tokens": [
				["text", "\/api\/v4\/people\/child\/edit"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"Api_v4_get_messages": {
			"tokens": [
				["variable", "\/", "[^\/]++", "limit"],
				["variable", "\/", "[^\/]++", "offset"],
				["text", "\/api\/v4\/people\/parent\/messages"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_all_bookings_for_parent": {
			"tokens": [
				["variable", "\/", "[^\/]++", "limit"],
				["variable", "\/", "[^\/]++", "offset"],
				["text", "\/api\/v4\/people\/bookings\/all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_current_bookings_feed": {
			"tokens": [
				["text", "\/api\/v4\/people\/bookings\/current\/feed"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_booking_detail_for_child": {
			"tokens": [
				["variable", "\/", "[^\/]++", "bookingId"],
				["variable", "\/", "[^\/]++", "clientId"],
				["text", "\/api\/v4\/people\/bookings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_add_person_client_connection": {
			"tokens": [
				["text", "\/club\/connection"],
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/api\/v4\/people"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_upload_person_avatar": {
			"tokens": [
				["text", "\/api\/v4\/people\/person\/avatar"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_add_new_payment_method": {
			"tokens": [
				["text", "\/api\/v4\/people\/person\/add_new_payment_method"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_saved_cards": {
			"tokens": [
				["text", "\/api\/v4\/people\/person\/saved-cards"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_photo_permissions": {
			"tokens": [
				["text", "\/api\/v4\/people\/person\/photo-permissions"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_update_photo_permissions": {
			"tokens": [
				["text", "\/api\/v4\/people\/person\/update-photo-permissions"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_get_logo_urls": {
			"tokens": [
				["text", "\/api\/v4\/client\/logo-urls"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_client_get_staff": {
			"tokens": [
				["text", "\/api\/v4\/client\/staff"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"Api_v4_client_get_all_staff": {
			"tokens": [
				["text", "\/api\/v4\/client\/all-staff"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"Api_v4_client_get_staff_registers": {
			"tokens": [
				["text", "\/api\/v4\/client\/staff-registers"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"Api_v4_client_deactivate_coach": {
			"tokens": [
				["variable", "\/", "[^\/]++", "staffId"],
				["text", "\/api\/v4\/client\/staff\/remove"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_revoke_coach": {
			"tokens": [
				["variable", "\/", "[^\/]++", "staffId"],
				["text", "\/api\/v4\/client\/staff\/revoke"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_reactivate_coach": {
			"tokens": [
				["variable", "\/", "[^\/]++", "staffId"],
				["text", "\/api\/v4\/client\/staff\/restore"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_update_staff_role": {
			"tokens": [
				["text", "\/api\/v4\/client\/staff\/update"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_get_quick_info": {
			"tokens": [
				["text", "\/api\/v4\/client\/quick-info"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_client_update_financials_access": {
			"tokens": [
				["text", "\/api\/v4\/client\/staff\/update-financial-access"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_get_settings": {
			"tokens": [
				["text", "\/api\/v4\/client\/settings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_client_get_payment_settings": {
			"tokens": [
				["text", "\/api\/v4\/client\/settings\/payments"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_client_get_invoices_from_stripe": {
			"tokens": [
				["text", "\/api\/v4\/client\/stripe\/invoices"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_get_invoice_detail_from_stripe": {
			"tokens": [
				["text", "\/api\/v4\/client\/stripe\/invoices\/detail"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_get_checkout_session_details": {
			"tokens": [
				["text", "\/api\/v4\/client\/get-subscription-details"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_check_for_stripe_subscription_started": {
			"tokens": [
				["text", "\/api\/v4\/client\/poll-stripe-for-subscription"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_client_connect_account_onboarding_url": {
			"tokens": [
				["text", "\/api\/v4\/client\/connect-account-url"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_terms_schedule": {
			"tokens": [
				["text", "\/api\/v4\/schedule\/terms"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_camps_schedule": {
			"tokens": [
				["text", "\/api\/v4\/schedule\/camps"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_mock_camp": {
			"tokens": [
				["text", "\/api\/v4\/mock\/camp\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_outstanding_orders_for_term": {
			"tokens": [
				["text", "\/outstanding-orders"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/api\/v4\/orders"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_order_detail_for_child": {
			"tokens": [
				["variable", "\/", "[^\/]++", "orderId"],
				["variable", "\/", "[^\/]++", "clientId"],
				["text", "\/api\/v4\/orders"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_upcoming_orders": {
			"tokens": [
				["text", "\/api\/v4\/orders\/get-upcoming-bookings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_send_sms_invoices": {
			"tokens": [
				["text", "\/api\/v4\/orders\/invoices\/sms"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_send_sms_confirmations": {
			"tokens": [
				["text", "\/api\/v4\/orders\/confirmations\/sms"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_all_subscriptions": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_successful_subscriptions": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/successful"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_not_set_up_subscriptions": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/not-set-up"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_problem_subscriptions": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/problem"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_waiting_subscriptions": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/waiting"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_cancelled_subscriptions": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/cancelled"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_payment_plans": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/plans"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_stripe_subscription": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/stripe-subscriptions"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_stripe_invoices": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/stripe-upcoming-invoices"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_sub_from_stripe": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/stripe"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_update_subscription_pause": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/pause"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_update_subscription_resume": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/resume"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_update_subscription_plan_for_person": {
			"tokens": [
				["variable", "\/", "[^\/]++", "planId"],
				["variable", "\/", "[^\/]++", "subscriptionId"],
				["text", "\/api\/v4\/subscriptions\/update"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_covering_payments_for_subscription": {
			"tokens": [
				["variable", "\/", "[^\/]++", "recurringPaymentSubscriptionId"],
				["text", "\/api\/v4\/subscriptions\/covering-payments"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_update_default_card_for_customer": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/outstanding-subscription-invoices\/update-default-card"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_refund_charge_from_subscription": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/charge\/refund"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_cancel_subscription": {
			"tokens": [
				["text", "\/cancel"],
				["variable", "\/", "[^\/]++", "subscriptionId"],
				["text", "\/api\/v4\/subscriptions"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_reactivate_subscription": {
			"tokens": [
				["text", "\/reactivate"],
				["variable", "\/", "[^\/]++", "subscriptionId"],
				["text", "\/api\/v4\/subscriptions"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_subs_summary": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/summary"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_prompt_parent_to_manage_subscription": {
			"tokens": [
				["text", "\/api\/v4\/subscriptions\/prompt"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_subscription_by_id": {
			"tokens": [
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/api\/v4\/subscriptions"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_stripe_account_status": {
			"tokens": [
				["text", "\/api\/v4\/stripe\/account\/status"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_get_stripe_account_link": {
			"tokens": [
				["text", "\/api\/v4\/stripe\/account\/link"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_send_sms_feedback_to_google_sheets": {
			"tokens": [
				["text", "\/api\/v4\/utility\/sms\/feedback"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_view_send_sms": {
			"tokens": [
				["text", "\/api\/v4\/messaging\/sms\/compose"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET", "POST"],
			"schemes": []
		},
		"Api_v4_preview_send_sms": {
			"tokens": [
				["text", "\/api\/v4\/messaging\/sms\/preview"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET", "POST"],
			"schemes": []
		},
		"Api_v4_view_sms_recipients": {
			"tokens": [
				["text", "\/api\/v4\/messaging\/sms\/recipients"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET", "POST"],
			"schemes": []
		},
		"Api_v4_send_sms_success": {
			"tokens": [
				["text", "\/api\/v4\/messaging\/sms\/success"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET", "POST"],
			"schemes": []
		},
		"Api_v4_sms_get_contacts": {
			"tokens": [
				["text", "\/api\/v4\/messaging\/sms\/get\/contacts"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_send_sms_message": {
			"tokens": [
				["text", "\/api\/v4\/messaging\/sms\/send-message"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_pay_for_client_order": {
			"tokens": [
				["text", "\/api\/v4\/payments\/pay-for-client-order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_set_up_subscription_client_for_order": {
			"tokens": [
				["text", "\/api\/v4\/payments\/pay-for-order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_get_bookings": {
			"tokens": [
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/api\/v4\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_hubspot_create_contact": {
			"tokens": [
				["text", "\/api\/v4\/hubspot\/create-contact"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Api_v4_auto_enrol_get_bookings": {
			"tokens": [
				["text", "\/bookings"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/api\/v4\/auto-enrol"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Api_v4_auto_enrol_make_bookings": {
			"tokens": [
				["text", "\/bookings"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/api\/v4\/auto-enrol"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Apibundle_new_magic_link": {
			"tokens": [
				["text", "\/api\/new-magic-link"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Apibundle_magic_link_login": {
			"tokens": [
				["text", "\/api\/magic-link-login"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_check_subdomain_status": {
			"tokens": [
				["text", "\/api\/subdomain-status-check"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_create_new_client": {
			"tokens": [
				["text", "\/api\/new-client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Apibundle_get_client_payment_information": {
			"tokens": [
				["text", "\/api\/payments-info"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Apibundle_get_payment_plans": {
			"tokens": [
				["text", "\/api\/payment-plans"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Apibundle_get_client_stripe_account": {
			"tokens": [
				["text", "\/api\/connect-stripe"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Apibundle_client_setup_stripe_account": {
			"tokens": [
				["text", "\/api\/connect-stripe"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"Apibundle_get_connect_existing_stripe_url": {
			"tokens": [
				["text", "\/api\/connect-stripe\/url"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Apibundle_get_list_of_available_timezones": {
			"tokens": [
				["text", "\/api\/timezones"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Apibundle_get_client_timezone": {
			"tokens": [
				["text", "\/api\/client\/timezone"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"Apibundle_set_client_timezone": {
			"tokens": [
				["text", "\/api\/client\/timezone"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_forgot_password_express": {
			"tokens": [
				["text", "\/api\/auth\/forgot-password-express"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_forgot_password_express_check": {
			"tokens": [
				["text", "\/api\/auth\/forgot-password-express-check"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_setting": {
			"tokens": [
				["variable", "\/", "[^\/]++", "setting"],
				["text", "\/api\/settings\/get"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_toggle_setting": {
			"tokens": [
				["variable", "\/", "[^\/]++", "setting"],
				["text", "\/api\/settings\/toggle"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_dropdown_setting": {
			"tokens": [
				["variable", "\/", "[^\/]++", "setting"],
				["text", "\/api\/settings\/dropdown"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_feature": {
			"tokens": [
				["variable", "\/", "[^\/]++", "feature"],
				["text", "\/api\/settings\/get\/feature"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_toggle_feature": {
			"tokens": [
				["variable", "\/", "[^\/]++", "feature"],
				["text", "\/api\/settings\/toggle\/feature"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_skin_custom_request": {
			"tokens": [
				["text", "\/api\/settings\/skins\/custom\/request"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_skin_custom_status": {
			"tokens": [
				["text", "\/api\/settings\/skins\/custom\/request"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_skin_custom_delete_request": {
			"tokens": [
				["text", "\/api\/settings\/skins\/custom\/request"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["DELETE"],
			"schemes": []
		},
		"ApiBundle_skin_custom_update": {
			"tokens": [
				["text", "\/update"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/settings\/skins\/custom"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_update_subscription_notes": {
			"tokens": [
				["text", "\/api\/settings\/subscriptions-notes"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_payment_methods": {
			"tokens": [
				["text", "\/api\/settings\/payment-methods"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_beta_status": {
			"tokens": [
				["text", "\/api\/settings\/beta\/status"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_set_beta_status": {
			"tokens": [
				["text", "}\/"],
				["variable", "", "[^\/]+", "status"],
				["text", "\/api\/settings\/beta\/{"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_trophies_status": {
			"tokens": [
				["text", "\/api\/settings\/trophies"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_toggle_trophies_status": {
			"tokens": [
				["text", "\/api\/settings\/trophies\/toggle"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_toggle_max_trophies_count": {
			"tokens": [
				["text", "\/api\/settings\/trophies\/maximum"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_toggle_bookable_trials": {
			"tokens": [
				["text", "\/api\/settings\/trials\/bookable"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_bookable_trials_setting": {
			"tokens": [
				["text", "\/api\/settings\/trials"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_sms_status": {
			"tokens": [
				["text", "\/api\/settings\/sms"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_toggle_sms_status": {
			"tokens": [
				["text", "\/api\/settings\/sms\/toggle"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_update_payment_settings": {
			"tokens": [
				["text", "\/api\/settings\/payment-settings\/update\/"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_update_platform_fees": {
			"tokens": [
				["text", "\/api\/settings\/platform-fees\/update\/"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_client_settings": {
			"tokens": [
				["text", "\/api\/settings\/client-settings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_update_client_settings": {
			"tokens": [
				["text", "\/api\/settings\/client-settings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_themes": {
			"tokens": [
				["text", "\/api\/settings\/themes"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_upload_logo": {
			"tokens": [
				["text", "\/api\/settings\/logo"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_update_skin": {
			"tokens": [
				["text", "\/api\/settings\/theme"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_reset_setup_fees": {
			"tokens": [
				["text", "\/api\/settings\/reset-setup-fees"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_payment_secures_booking_settings": {
			"tokens": [
				["text", "\/api\/settings\/payment-secures-booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_club": {
			"tokens": [
				["text", "\/api\/club\/club"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_charts_dashboard_payment_breakdown": {
			"tokens": [
				["text", "\/api\/charts\/dashboard\/payment-breakdown"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_charts_dashboard_daily_revenue": {
			"tokens": [
				["text", "\/api\/charts\/dashboard\/daily-revenue"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_get_camps": {
			"tokens": [
				["text", "\/api\/camps\/all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_camp_by_id": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/camps\/camp"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_camp_get_invite_only_status": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/camps\/invite-only"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_camp_toggle_invite_only": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/api\/camps\/invite-only"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_add_instance_to_booking": {
			"tokens": [
				["text", "\/api\/bookings\/booking\/add-instance"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_remove_instance_from_booking": {
			"tokens": [
				["text", "\/api\/bookings\/booking\/remove-instance"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_send_trial_extend_email": {
			"tokens": [
				["text", "\/send-trial-extend-email"],
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/api\/bookings\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_end_trial": {
			"tokens": [
				["text", "\/end-trial"],
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/api\/bookings\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_extend_trial": {
			"tokens": [
				["text", "\/extend-trial"],
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/api\/bookings\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_book_trial_from_waiting_list": {
			"tokens": [
				["text", "\/api\/bookings\/book-trial-from-waiting-list"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_change_trial_date": {
			"tokens": [
				["text", "\/change-trial-date"],
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/api\/bookings\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_book_trial": {
			"tokens": [
				["text", "\/api\/bookings\/book-trial"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_book_trial_v2": {
			"tokens": [
				["text", "\/api\/bookings\/book-trial\/v2"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_unreject_trial": {
			"tokens": [
				["text", "\/api\/bookings\/unreject-trial"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_booking": {
			"tokens": [
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/api\/bookings\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_bookings_cancel_booking": {
			"tokens": [
				["text", "\/cancel"],
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/api\/bookings\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_book_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/bookings\/bookings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_bookings_book_on_to_waiting_list": {
			"tokens": [
				["text", "\/"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/bookings\/waiting-list\/add"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_remove_multiple_from_waiting_list": {
			"tokens": [
				["text", "\/api\/bookings\/waiting-list\/remove-all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"BookingBundle_remove_multiple_from_camp_waiting_list": {
			"tokens": [
				["text", "\/camps\/waiting-list\/remove-all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_check_discount_code_status": {
			"tokens": [
				["text", "\/api\/discounts\/discount-code-status-check"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_discount_codes": {
			"tokens": [
				["text", "\/api\/discounts\/discount-codes"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_register_update_attendance": {
			"tokens": [
				["variable", "\/", "[^\/]++", "status"],
				["variable", "\/", "[^\/]++", "bookingInstanceId"],
				["text", "\/attendance"],
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/booking"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/registers\/register"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST", "GET"],
			"schemes": []
		},
		"ApiBundle_register_update_contact_attribute": {
			"tokens": [
				["text", "\/api\/registers\/contact-attributes\/update"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_register_update_setup_fee_status": {
			"tokens": [
				["text", "\/update"],
				["variable", "\/", "[^\/]++", "childId"],
				["text", "\/api\/registers\/setup-fee"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_register_get_payments": {
			"tokens": [
				["text", "\/api\/registers\/payments"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_register_get_waiting_list": {
			"tokens": [
				["text", "\/api\/registers\/waiting-list"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_register_book_from_waiting_list": {
			"tokens": [
				["variable", "\/", "[^\/]++", "waitingListEntryId"],
				["variable", "\/", "[^\/]++", "childId"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/registers\/waiting-list"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_register_get_emergency_contacts": {
			"tokens": [
				["text", "\/api\/registers\/emergency-contacts"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_register_get_trials": {
			"tokens": [
				["text", "\/api\/registers\/trials"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_register_active_bookings": {
			"tokens": [
				["text", "\/api\/registers\/bookings"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_register_setup_fees": {
			"tokens": [
				["text", "\/api\/registers\/setup-fees"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_register_club_contact_attributes": {
			"tokens": [
				["text", "\/api\/registers\/club-contact-attributes"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_register_contact_attributes": {
			"tokens": [
				["text", "\/api\/registers\/contact-attributes"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_rerun_add_run": {
			"tokens": [
				["text", "\/api\/rerun\/add-run"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_term_auto_enroll": {
			"tokens": [
				["variable", "\/", "[^\/]++", "step"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/api\/auto-enrol\/schedule\/terms\/auto-enroll"]
			],
			"defaults": {
				"step": "select-kids"
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_term_auto_enroll_child_to_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "childId"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/auto-enrol\/schedule\/runs\/auto-enroll"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_term_auto_enroll_send_confirmation": {
			"tokens": [
				["text", "\/send-confirmation"],
				["variable", "\/", "[^\/]++", "orderId"],
				["text", "\/api\/auto-enrol\/order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_orders_apply_discounts": {
			"tokens": [
				["text", "\/apply-discounts"],
				["variable", "\/", "[^\/]++", "orderId"],
				["text", "\/api\/auto-enrol\/order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_term_auto_enroll_family": {
			"tokens": [
				["text", "\/api\/auto-enrol\/schedule\/runs\/auto-enroll-family"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_register_get_trophies": {
			"tokens": [
				["text", "\/trophies"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/grading\/register"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_register_update_trophies": {
			"tokens": [
				["variable", "\/", "[^\/]++", "status"],
				["variable", "\/", "[^\/]++", "runInstanceId"],
				["text", "\/trophy"],
				["variable", "\/", "[^\/]++", "childId"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/grading\/register"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_financial_report": {
			"tokens": [
				["text", "\/api\/financial\/report"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_get_financial_report_summary": {
			"tokens": [
				["text", "\/api\/financial\/report\/summary"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_get_franchise_financial_report_summary": {
			"tokens": [
				["text", "\/api\/financial\/franchise\/summary"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_orders_getOutstandingBalance": {
			"tokens": [
				["text", "\/api\/orders\/get-payments-due"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_orders_getTotalPaid": {
			"tokens": [
				["text", "\/api\/orders\/get-total-payments"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_orders_send_invoice": {
			"tokens": [
				["text", "\/send-invoice"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/orders\/order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_orders_send_invoices": {
			"tokens": [
				["text", "\/api\/orders\/send-invoices"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_orders_send_order_invoice": {
			"tokens": [
				["text", "\/api\/orders\/send-order-invoice"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_pay_order_item_coach": {
			"tokens": [
				["text", "\/pay"],
				["variable", "\/", "[^\/]++", "orderItemId"],
				["text", "\/api\/orders\/order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_get_order_payments": {
			"tokens": [
				["text", "\/payments"],
				["variable", "\/", "[^\/]++", "orderId"],
				["text", "\/api\/orders\/order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_create_order": {
			"tokens": [
				["text", "\/api\/orders\/order\/create"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_subscriptions_getTotalSubscriptions": {
			"tokens": [
				["text", "\/api\/subscriptions\/get-subscriptions-total"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_subscriptions_getFailedSubscriptions": {
			"tokens": [
				["text", "\/api\/subscriptions\/get-subscriptions-failed"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_subscriptions_payment_log": {
			"tokens": [
				["text", "\/api\/subscriptions\/payment-log"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_subscriptions_covering_payment": {
			"tokens": [
				["text", "\/api\/subscriptions\/covering-payments"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_subscriptions_get_pending_subscriptions_for_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/subscriptions\/pending"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_subscriptions_get_problem_susbscriptions_for_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/subscriptions\/problem"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_subscription_remove_covering_payment": {
			"tokens": [
				["variable", "\/", "[^\/]++", "subscriptionCoveringPaymentId"],
				["text", "\/api\/subscriptions\/remove-covering-payment"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_subscription_add_covering_payment": {
			"tokens": [
				["variable", "\/", "[^\/]++", "recurringPaymentSubscriptionId"],
				["text", "\/api\/subscriptions\/add-covering-payment"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_update_subscription_plan": {
			"tokens": [
				["variable", "\/", "[^\/]++", "planId"],
				["text", "\/api\/subscriptions\/update"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_all_subscribed_to_plan": {
			"tokens": [
				["text", "\/subscribers"],
				["variable", "\/", "[^\/]++", "planId"],
				["text", "\/api\/subscriptions\/get"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_update_subscription_plan_at_stripe_for_person": {
			"tokens": [
				["text", "\/api\/subscriptions\/update-plan-stripe"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_subscription_details_from_stripe": {
			"tokens": [
				["variable", "\/", "[^\/]++", "stripeSubscriptionId"],
				["text", "\/api\/subscriptions\/get\/stripe"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_messaging_send_message": {
			"tokens": [
				["text", "\/api\/messaging\/send"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_messaging_send_email_message": {
			"tokens": [
				["text", "\/api\/messaging\/send-messages"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_messaging_invite_to_run": {
			"tokens": [
				["text", "\/"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/messaging\/invite"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_messaging_send_booking_confirmation": {
			"tokens": [
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/api\/messaging\/booking-confirmation"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_messaging_resend_message": {
			"tokens": [
				["text", "\/resend"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/messaging\/message"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_get_communications_log": {
			"tokens": [
				["text", "\/api\/messaging\/communications-log"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_archive_record": {
			"tokens": [
				["text", "\/api\/messaging\/archive\/"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_unarchive_record": {
			"tokens": [
				["text", "\/api\/messaging\/unarchive\/"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_sms_order_invoice": {
			"tokens": [
				["text", "\/api\/messaging\/sms\/"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_comms_log_for_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/messaging\/comms-log"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_get_previously_invited_to_run": {
			"tokens": [
				["text", "\/"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/messaging\/invited"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_franchise_contacts": {
			"tokens": [
				["text", "\/api\/franchise\/contacts\/contacts"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_get_contacts_with_client_meta_data": {
			"tokens": [
				["text", "\/api\/contacts\/all-contacts"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_contacts_basic": {
			"tokens": [
				["text", "\/api\/contacts\/contacts"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_parents_basic": {
			"tokens": [
				["text", "\/api\/contacts\/contacts\/parents"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_children_by_id": {
			"tokens": [
				["text", "\/children"],
				["variable", "\/", "[^\/]++", "parentPersonId"],
				["text", "\/api\/contacts\/contacts"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_parents_email_and_mobile": {
			"tokens": [
				["text", "\/api\/contacts\/contacts\/verified-list"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_manage_get_clients": {
			"tokens": [
				["text", "\/api\/manage\/clients"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_client_premium_listing": {
			"tokens": [
				["text", "\/pemium-listing"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_client_status": {
			"tokens": [
				["text", "\/status"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_get_client": {
			"tokens": [
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_client_update_feature": {
			"tokens": [
				["variable", "\/", "[^\/]++", "featureKey"],
				["text", "\/features"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_client_update_setting": {
			"tokens": [
				["variable", "\/", "[^\/]++", "key"],
				["text", "\/setting"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_client_update_subdomain": {
			"tokens": [
				["text", "\/subdomain"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_client_get_skins": {
			"tokens": [
				["text", "\/api\/manage\/skins"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_manage_client_update_skin": {
			"tokens": [
				["text", "\/skin"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_client_update_monthly_price": {
			"tokens": [
				["text", "\/monlthy-cost"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_client_update_rates": {
			"tokens": [
				["text", "\/rates"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_manage_pass_on_clubs": {
			"tokens": [
				["text", "\/api\/manage\/passonclubs"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_manage_pass_on_stats": {
			"tokens": [
				["text", "\/api\/manage\/stats"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_mock_data": {
			"tokens": [
				["text", "\/api\/manage\/mockdata"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_manage_client_reporting_": {
			"tokens": [
				["text", "\/absorbedStats"],
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/api\/manage\/client"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_all_runs": {
			"tokens": [
				["text", "\/api\/runs\/all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_update_invite_only": {
			"tokens": [
				["text", "\/invite-only"],
				["variable", "\/", "[^\/]++", "id"],
				["text", "\/api\/runs"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_run_get_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/runs"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_run_get_run_v2": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/runs\/v2"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_run_get_run_v3": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/runs\/v3"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_run_get_run_details": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/runs\/run"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_add_date_to_run": {
			"tokens": [
				["text", "\/add-date"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/runs"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_term_get_schedule": {
			"tokens": [
				["text", "\/api\/terms\/schedule"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_term_get_terms": {
			"tokens": [
				["text", "\/api\/terms\/terms\/all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_term_get_terms_v2": {
			"tokens": [
				["text", "\/api\/terms\/terms"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_invite_only_terms": {
			"tokens": [
				["variable", "\/", "[^\/]++", "status"],
				["text", "\/invite-only"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/api\/terms\/term"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_orders_update_parent_details_v2": {
			"tokens": [
				["text", "\/api\/people\/update_parent_details\/v2"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_orders_update_parent_email": {
			"tokens": [
				["text", "\/update_parent_email"],
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/api\/people"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_orders_get_parent_details": {
			"tokens": [
				["text", "\/get_parent_details\/"],
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/api\/people"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ApiBundle_update_child_notes": {
			"tokens": [
				["text", "\/update_child_notes\/"],
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/api\/people"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_staff_get_coaches_by_user_id": {
			"tokens": [
				["text", "\/api\/staff\/coaches\/by-id"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_staff_get_all_active_coaches": {
			"tokens": [
				["text", "\/api\/staff\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_staff_get_all_active_coaches_for_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/staff\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_staff_add_coach_to_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "userId"],
				["text", "\/add"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/staff\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_staff_remove_coach_from_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "userId"],
				["text", "\/remove"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/api\/staff\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_add_registration_question": {
			"tokens": [
				["text", "\/api\/registration-questions\/add"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_registration_question": {
			"tokens": [
				["variable", "\/", "[^\/]++", "id"],
				["text", "\/api\/registration-questions\/get"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_all_registration_questions": {
			"tokens": [
				["text", "\/api\/registration-questions\/all"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_update_registration_question": {
			"tokens": [
				["variable", "\/", "[^\/]++", "id"],
				["text", "\/api\/registration-questions\/update"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_delete_registration_question": {
			"tokens": [
				["variable", "\/", "[^\/]++", "id"],
				["text", "\/api\/registration-questions\/delete"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_toggle_registration_question_active": {
			"tokens": [
				["variable", "\/", "[^\/]++", "id"],
				["text", "\/api\/registration-questions\/toggle-active"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_get_contact_registration_questions_emergency_contacts": {
			"tokens": [
				["text", "\/contacts-answers\/"],
				["variable", "\/", "[^\/]++", "id"],
				["text", "\/api\/registration-questions"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_runs": {
			"tokens": [
				["text", "\/api\/reports\/ASMO\/runs"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_distinct_participants": {
			"tokens": [
				["text", "\/api\/reports\/ASMO\/distinct-participants"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_get_asmo_report": {
			"tokens": [
				["text", "\/api\/reports\/ASMO\/report"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_list_active_classes": {
			"tokens": [
				["text", "\/api\/listing\/classes"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_list_active_venues": {
			"tokens": [
				["text", "\/api\/listing\/venues"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_list_class_activities": {
			"tokens": [
				["text", "\/api\/listing\/class-activities"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["GET"],
			"schemes": []
		},
		"ApiBundle_add_class": {
			"tokens": [
				["text", "\/api\/listing\/class"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ApiBundle_add_venue": {
			"tokens": [
				["text", "\/api\/listing\/venue"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": ["POST"],
			"schemes": []
		},
		"ParentDashboard_delete_saved_card": {
			"tokens": [
				["text", "\/delete"],
				["variable", "\/", "[^\/]++", "cardId"],
				["text", "\/dashboard\/details\/me\/cards"]
			],
			"defaults": {
				"domain": "class4kids",
				"tld": "co.uk"
			},
			"requirements": {
				"domain": "class4kids|staging.class4kids|classforkids|staging.classforkids|class4kids|docker.sandbox.classforkids|richard.sandbox.classforkids",
				"tld": "club|co.nz|co.uk|ie|io|local|dev|co.uk"
			},
			"hosttokens": [
				["variable", ".", "club|co.nz|co.uk|ie|io|local|dev|co.uk", "tld"],
				["variable", ".", "class4kids|staging.class4kids|classforkids|staging.classforkids|class4kids|docker.sandbox.classforkids|richard.sandbox.classforkids", "domain"],
				["text", "bookings"]
			],
			"methods": [],
			"schemes": []
		},
		"PublicBookingBundle_homepage": {
			"tokens": [
				["text", "\/"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"PublicBookingBundle_run_info": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/info"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"PublicBookingBundle_camp_info": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/camp"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"PublicBookingBundle_term_listing": {
			"tokens": [
				["variable", "\/", "[^\/]++", "termName"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/term"]
			],
			"defaults": {
				"termName": null
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_schedule": {
			"tokens": [
				["text", "\/cms\/schedule"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_add_term": {
			"tokens": [
				["text", "\/cms\/schedule\/terms\/add"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_edit_term": {
			"tokens": [
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/cms\/schedule\/terms\/edit"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_delete_term": {
			"tokens": [
				["text", "\/delete"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/cms\/schedule\/term"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_rerun_term": {
			"tokens": [
				["variable", "\/", "[^\/]++", "step"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/cms\/schedule\/terms\/re-run"]
			],
			"defaults": {
				"step": 1
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_invoice_by_term": {
			"tokens": [
				["text", "\/invoice-by-term"],
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/cms\/schedule\/terms"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_schedule_add_run": {
			"tokens": [
				["text", "\/cms\/schedule\/runs\/add"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_schedule_edit_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/cms\/schedule\/runs\/edit"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClassListingBundle_schedule_delete_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/cms\/schedule\/runs\/delete"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_termpage": {
			"tokens": [
				["variable", "\/", "[^\/]++", "termId"],
				["text", "\/cms\/contacts\/term"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_runpage": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/cms\/contacts\/run"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_camppage": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/cms\/contacts\/camp"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_camppage_weeks": {
			"tokens": [
				["variable", "\/", "[^\/]++", "weekInstanceGroupIds"],
				["text", "\/cms\/contacts\/camp\/weeks"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_schedulepage": {
			"tokens": [
				["text", "\/"],
				["variable", "\/", "[^\/]++", "runIds"],
				["text", "\/cms\/contacts\/schedule"]
			],
			"defaults": [],
			"requirements": {
				"tags": "[a-zA-Z0-9\/]+"
			},
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_add_contact": {
			"tokens": [
				["variable", "\/", "[^\/]++", "parentId"],
				["variable", "\/", "[^\/]++", "step"],
				["text", "\/cms\/contacts\/add"]
			],
			"defaults": {
				"step": 1,
				"parentId": null
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_view_contact": {
			"tokens": [
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/cms\/contacts\/view"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_edit_child": {
			"tokens": [
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/cms\/contacts\/edit-child"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_delete_contact": {
			"tokens": [
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/cms\/contacts\/remove"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle_mark_setupfee": {
			"tokens": [
				["variable", "\/", "[^\/]++", "status"],
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/cms\/contacts\/setup-fee"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ContactsBundle__view_emergency_camp": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/cms\/contacts\/emergency\/camp"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"BookingBundle_book_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "prorata"],
				["variable", "\/", "[^\/]++", "childId"],
				["variable", "\/", "[^\/]++", "step"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/cms\/bookings\/book"]
			],
			"defaults": {
				"step": "choose-child",
				"childId": null,
				"prorata": null
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"BookingBundle_invite_to_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "step"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/cms\/bookings\/invite"]
			],
			"defaults": {
				"step": "choose-emails"
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"BookingBundle_booking_detail": {
			"tokens": [
				["variable", "\/", "[^\/]++", "bookingRef"],
				["text", "\/cms\/bookings\/booking"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"BookingBundle_show_register": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/cms\/bookings\/register"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"BookingBundle_transfer_to_another_waiting_list": {
			"tokens": [
				["variable", "\/", "[^\/]++", "newRunId"],
				["variable", "\/", "[^\/]++", "childId"],
				["text", "\/move-to-another-waiting-list"],
				["variable", "\/", "[^\/]++", "currentRunId"],
				["text", "\/cms\/bookings\/register"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"BookingBundle_large_rebook_from_register": {
			"tokens": [
				["text", "\/rebooklarge"],
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/cms\/bookings\/register"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"PaymentBundle_list_plans": {
			"tokens": [
				["text", "\/cms\/payments\/recurring\/plans"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"PaymentBundle_change_parent_plan": {
			"tokens": [
				["text", "\/change-plan"],
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/cms\/contacts\/parent"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"PaymentBundle_cancel_subscription": {
			"tokens": [
				["text", "\/cancel"],
				["variable", "\/", "[^\/]++", "recurringPaymentSubscriptionId"],
				["text", "\/cms\/subscription"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"PaymentBundle_manage_subscription": {
			"tokens": [
				["text", "\/manage"],
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/cms\/subscription"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"FinancialsBundle_summary": {
			"tokens": [
				["text", "\/cms\/financials"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"Notification_send_message": {
			"tokens": [
				["variable", "\/", "[^\/]++", "personId"],
				["text", "\/cms\/communications\/send-message"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"Notification_send_group_message": {
			"tokens": [
				["variable", "\/", "[^\/]++", "step"],
				["text", "\/cms\/communications\/send-group-message"]
			],
			"defaults": {
				"step": "preview"
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_homepage": {
			"tokens": [
				["text", "\/cms\/"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_settings_stripe_connect": {
			"tokens": [
				["text", "\/cms\/settings\/stripe-connect"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_subscription_plan": {
			"tokens": [
				["text", "\/cms\/settings\/subscription"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_client_subscription_payment_plan": {
			"tokens": [
				["text", "\/cms\/settings\/getPaymentPlan"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_coaches": {
			"tokens": [
				["text", "\/cms\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_add_coach": {
			"tokens": [
				["text", "\/cms\/coaches\/add"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_coach_add_to_register": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/add-to-register"],
				["variable", "\/", "[^\/]++", "coachId"],
				["text", "\/cms\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_coach_remove_from_register": {
			"tokens": [
				["variable", "\/", "[^\/]++", "runId"],
				["text", "\/remove-from-register"],
				["variable", "\/", "[^\/]++", "coachId"],
				["text", "\/cms\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_coach_add_to_camp": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/add-to-camp"],
				["variable", "\/", "[^\/]++", "coachId"],
				["text", "\/cms\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_coach_remove_from_camp": {
			"tokens": [
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/remove-from-camp"],
				["variable", "\/", "[^\/]++", "coachId"],
				["text", "\/cms\/coaches"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_termsconditions_settings": {
			"tokens": [
				["text", "\/cms\/settings\/terms-and-conditions"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"ClientBundle_privacy_settings": {
			"tokens": [
				["text", "\/cms\/settings\/privacy"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"BasketBundle_view_order": {
			"tokens": [
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"CMSBasketBundle_view_order": {
			"tokens": [
				["variable", "\/", "[^\/]++", "uuid"],
				["text", "\/cms\/order"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"CMSBasketBundle_ajax_orders": {
			"tokens": [
				["text", "\/cms\/orders\/ajax"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"CampBundle_add_camp": {
			"tokens": [
				["variable", "\/", "[^\/]++", "step"],
				["text", "\/cms\/camps\/add"]
			],
			"defaults": {
				"step": "details"
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"CampBundle_delete_camp": {
			"tokens": [
				["text", "\/delete"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/cms\/camp"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"CampBundle_edit_camp": {
			"tokens": [
				["text", "\/edit"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/cms\/camp"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"CampBundle_camp_register": {
			"tokens": [
				["variable", "\/", "[^\/]++", "weekId"],
				["text", "\/week"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/cms\/camps\/register"]
			],
			"defaults": {
				"weekId": null
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"CampBundle_camp_book": {
			"tokens": [
				["variable", "\/", "[^\/]++", "childId"],
				["variable", "\/", "[^\/]++", "step"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/cms\/camps\/book"]
			],
			"defaults": {
				"step": "choose-child",
				"childId": null
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"CampBundle_invite_to_run": {
			"tokens": [
				["variable", "\/", "[^\/]++", "step"],
				["variable", "\/", "[^\/]++", "campId"],
				["text", "\/cms\/camps\/invite"]
			],
			"defaults": {
				"step": "choose-emails"
			},
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"TransitionBundle_set_up_stripe": {
			"tokens": [
				["text", "\/cms\/transition\/setup\/setUpStripe"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		},
		"TransitionBundle_payment_overview": {
			"tokens": [
				["text", "\/cms\/transition\/splash\/payment"]
			],
			"defaults": [],
			"requirements": [],
			"hosttokens": [],
			"methods": [],
			"schemes": []
		}
	},
	"prefix": "",
	"host": "localhost",
	"port": "",
	"scheme": "http",
	"locale": []
});
